import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { Box, IconButton, MenuItem, Paper, Popper, Select } from '@mui/material'
import { useState } from 'react'

import { FUNNEL_LABELS } from '../constants.ts'

export const FunnelFilterHeader = ({
  value,
  onChange,
}: {
  value: string | undefined
  onChange: (val: string | undefined) => void
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <span style={{ fontWeight: 600 }}>Funnel</span>
      </Box>
      <Box
        sx={{
          ml: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <IconButton
          size="small"
          onClick={e => {
            e.stopPropagation()
            setAnchorEl(prev => (prev ? null : e.currentTarget))
          }}
          sx={{
            p: 0.25,
            color: value ? 'primary.main' : 'action.active',
          }}
        >
          <FilterAltIcon fontSize="small" />
        </IconButton>
      </Box>
      <Popper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        placement="bottom-start"
        sx={{ zIndex: 'modal' }}
      >
        <Paper
          elevation={8}
          sx={{
            p: 2,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mt: 0.5,
          }}
        >
          <Select
            value={value ?? ''}
            onChange={e => {
              const val = e.target.value
              onChange(val || undefined)
              setAnchorEl(null)
            }}
            displayEmpty
            size="small"
            sx={{ minWidth: 140 }}
          >
            <MenuItem value="">All</MenuItem>
            {Object.entries(FUNNEL_LABELS).map(([value, label]) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </Paper>
      </Popper>
    </Box>
  )
}
